import {
  createFeaturedVenues,
  deleteFeaturedVenues,
  updateFeaturedVenues,
} from '@store/FeaturedVenuesReducer'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import dayjs from 'dayjs'
import { forwardRef } from 'react'
import Create from './Create'
import Delete from './Delete'
import Update from './Update'

export const FeaturedVenuesForm: SBRMForm = forwardRef(({ formProps }, ref) => {
  const dispatch = useAppDispatch()
  const { error } = useAppSelector((state) => state.featuredVenues)

  return (
    <SBRM.BaseEntityForm
      {...{ ref, formProps }}
      error={error && String(error)}
      formActions={{
        create: Create,
        update: Update,
        delete: Delete,
      }}
      handlers={{
        create: async (values) => {
          const { dates, ...restValues } = values
          const updatedValues = {
            ...restValues,
            startDate: dayjs(dates[0]).format('YYYY-MM-DD'),
            endDate: dayjs(dates[1]).format('YYYY-MM-DD'),
          }
          return dispatch(createFeaturedVenues(updatedValues)).then(() => {
            return true
          })
        },
        update: async (values) => {
          const { dates, ...restValues } = values
          const updatedValues = {
            ...restValues,
            startDate: dayjs(dates[0]).format('YYYY-MM-DD'),
            endDate: dayjs(dates[1]).format('YYYY-MM-DD'),
          }
          return dispatch(updateFeaturedVenues(updatedValues)).then(() => {
            return true
          })
        },
        delete: async (values) =>
          dispatch(deleteFeaturedVenues(values)).then(() => {
            return true
          }),
      }}
    />
  )
})

FeaturedVenuesForm.displayName = 'FeaturedVenuesForm'

export default FeaturedVenuesForm
